import { DATA_VIEW_MODES } from "@store/ui/ui-slice-constants";
import { LocalStorageUtils } from "@utils/local-storage-utils";

/** The default data view mode */
const DEFAULT_VIEW_MODE = "cards";

/**
 * Type guard to check if a value is a valid DataViewMode.
 * @returns true if the value is a valid DataViewMode, false otherwise.
 * @param value The value to check.
 */
export function isDataViewMode(value) {
  return DATA_VIEW_MODES.some(viewMode => viewMode === value);
}

/**
 * Gets the current data view mode for each subject.
 * It also ensures that the data view mode is stored in the local storage for future reference.
 * @returns A record mapping each DataViewModeSubject to its current DataViewMode.
 */
export function getDataViewMode() {
  const stored = LocalStorageUtils.getJSONItem("data-view-mode");
  const dataViewMode = {
    projects: isDataViewMode(stored?.projects) ? stored.projects : DEFAULT_VIEW_MODE,
    groups: isDataViewMode(stored?.groups) ? stored.groups : DEFAULT_VIEW_MODE
  };
  LocalStorageUtils.setJSONItem("data-view-mode", dataViewMode);
  return dataViewMode;
}